var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.055,
    height: 15.051,
    viewBox: "0 0 15.055 15.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6,18.814l5.377-5.377a1.26,1.26,0,1,0-1.782-1.782l-5.377,5.377-5.377-5.377a1.26,1.26,0,1,0-1.782,1.782l5.377,5.377-5.377,5.377a1.26,1.26,0,1,0,1.782,1.782L18.814,20.6l5.377,5.377a1.26,1.26,0,1,0,1.782-1.782Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconWhite);
export default __webpack_public_path__ + "static/media/x_icon_white.cf18058b7873bbe3e723797c0de05a1e.svg";
export { ForwardRef as ReactComponent };